import MainHeader from "@coworker/apprestructured/src/layout/components/MainHeader/MainHeader";
import MainContent from "@coworker/apprestructured/src/layout/components/MainContent/MainContent";
import { Outlet } from "react-router";
import { BottomNavigation } from "@coworker/apprestructured/src/layout/components/BottomNavigation/BottomNavigation";
import OfflineBar from "@coworker/app/src/components/Layout/OfflineBar";
import MainNavigation from "@coworker/apprestructured/src/layout/components/MainNavigation/MainNavigation";
import React from "react";
import { useOnline } from "@coworker/app/src/core/hooks/useOnline";

export const MainLayout = () => {
  const mainContentScroll = true;
  const { isOnline, isReconnecting } = useOnline();
  return (
    <>
      <MainHeader />
      <MainContent scroll={mainContentScroll}>
        <Outlet />
      </MainContent>
      <BottomNavigation />
      {!isOnline && <OfflineBar isReconnecting={isReconnecting} />}
      <MainNavigation />
    </>
  );
};
